import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatCard } from '../components/StatCard';
import { statsData, recentActivity, riskData } from '../data/mockData';
import { Target, Activity, AlertTriangle, Shield, Clock, Zap } from 'lucide-react';

export default function Dashboard() {
  const navigate = useNavigate();
  
  return (
    <div className="page-container" data-testid="dashboard-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="page-subtitle">Security operations overview</p>
        </div>
        <button 
          className="btn-primary"
          onClick={() => navigate('/new-scan')}
          data-testid="quick-scan-button"
        >
          <Zap size={18} />
          <span>Quick Scan</span>
        </button>
      </div>

      <div className="stats-grid">
        <StatCard 
          title="Total Audits" 
          value={statsData.totalAudits} 
          icon={Target}
        />
        <StatCard 
          title="Active Scans" 
          value={statsData.activeScans} 
          icon={Activity}
        />
        <StatCard 
          title="Critical Vulnerabilities" 
          value={statsData.criticalVulnerabilities} 
          icon={AlertTriangle}
        />
        <StatCard 
          title="Expiring Authorizations" 
          value={statsData.expiringAuthorizations} 
          icon={Shield}
        />
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2 className="card-title">Recent Activity</h2>
          <div className="activity-list" data-testid="recent-activity-list">
            {recentActivity.map(activity => (
              <div key={activity.id} className="activity-item" data-testid={`activity-item-${activity.id}`}>
                <div className="activity-content">
                  <Clock className="activity-icon" />
                  <div>
                    <p className="activity-message">{activity.message}</p>
                    <span className="activity-time">{activity.time}</span>
                  </div>
                </div>
                <span className={`activity-badge badge-${activity.severity}`}>
                  {activity.severity}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="dashboard-card">
          <h2 className="card-title">Risk Summary</h2>
          <div className="risk-chart" data-testid="risk-chart">
            {riskData.map((risk, idx) => (
              <div key={idx} className="risk-bar-wrapper">
                <div className="risk-label">
                  <span>{risk.name}</span>
                  <span className="risk-value">{risk.value}</span>
                </div>
                <div className="risk-bar">
                  <div 
                    className="risk-bar-fill"
                    style={{ 
                      width: `${(risk.value / 200) * 100}%`,
                      backgroundColor: risk.color 
                    }}
                    data-testid={`risk-bar-${risk.name.toLowerCase()}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
